import { Component, OnDestroy, OnInit } from '@angular/core';
import { AdminService } from '../../../_services/admin.service';
import { Permissions } from '../../../_services/permissions';
import { ACLFeature } from '../../../_models/acl-feature';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'edit-userexport',
  styleUrls: ['userexport.less'],
  templateUrl: 'userexport.component.html',
})
export class UserexportComponent implements OnInit {

  canExportUserCatalog = false;

  constructor(
    private admin: AdminService,
    private permissions: Permissions,
    private router: Router
  ) {}

  ngOnInit() {
    this.permissions.hasFeature(ACLFeature.EXPORT_USER_CATALOG)
      .subscribe((success) => {
        this.canExportUserCatalog = success;
      });
  }

  exportUserCatalog() {
    this.admin.downloadUserCatalog().subscribe((res) => {
      //noinspection TypeScriptUnresolvedFunction
      const now = new Date();
      FileSaver.saveAs(res, `user-catalog-${now.toISOString()}.xlsx`);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/management/components/userexport/userexport.component.ts